// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".USX5d{position:relative;padding:2.5rem 0}.xByFf{margin-bottom:1rem;font-size:24px;font-size:1.5rem;font-weight:500;line-height:30px;line-height:1.875rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:767px){.xByFf{font-size:1.25rem;line-height:1.5625rem}}._2w2NQ{white-space:pre-wrap;font-size:16px;font-weight:300;line-height:26px;font-family:var(--base-font)}._2w2NQ ul{list-style:disc;margin:1rem 2rem}._2w2NQ ol{list-style:bullet;margin:1rem 2rem}._2w2NQ img{max-width:100%;margin:1rem 0}._2w2NQ h1{font-size:18px;line-height:25px}._2w2NQ h1,._2w2NQ h2{margin:1rem 0;font-weight:500;font-family:var(--heading-font);letter-spacing:.5px}._2w2NQ h2{font-size:16px;line-height:20px}._2w2NQ h3,._2w2NQ h4,._2w2NQ h5,._2w2NQ h6{margin:1rem 0;font-size:16px;font-weight:400;line-height:26px;font-family:var(--base-font)}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "USX5d",
	"title": "xByFf",
	"content": "_2w2NQ"
};
module.exports = exports;
